export default __webpack_public_path__ + "static/media/Edge of Shaulun.cd44d92a.jpg";